// @ts-nocheck
import { gsap } from "gsap";
// declare var gsap: any;
// document.addEventListener('DOMContentLoaded', (event) => {
//     scrollingPage()
// })

const detailProject = (()=>{
    const revealImageProject = () => {
        const imageReveal = document.querySelector('.detailProject__nextProject__image'),
            textHoverReveal = document.querySelector('#textRevealImage'),
            setX = gsap.quickSetter(imageReveal, "x", "px"),
            setY = gsap.quickSetter(imageReveal, "y", "px"),
            align = e => {
                const top = textHoverReveal?.getBoundingClientRect().top;
                const left = textHoverReveal?.getBoundingClientRect().left;
                setX(e.clientX - left);
                setY(e.clientY - top)
            },
            startFollow = () => document.addEventListener("mousemove", align),
            stopFollow = () => document.removeEventListener("mousemove", align),
            fade = gsap.to(imageReveal, { autoAlpha: 1, ease: "none", paused: true, onReverseComplete: stopFollow });
        textHoverReveal.addEventListener('mouseenter', (e) => {
            fade.play();
            startFollow();
            align(e);
        });
    
        textHoverReveal.addEventListener('mouseleave', () => fade.reverse());
    }

    return { 
        childsDetailProject : function(){
            try{revealImageProject();}catch(err){ }
        }
    }
})();

const getChildsDetailProject = ()=>{
    detailProject.childsDetailProject();
}

export { getChildsDetailProject }

/*-------------------------------------------*/


const detailProjectmin = (()=>{
    const revealImageProjectmin = () => {
        const imageRevealmin = document.querySelector('.detailProject__prevProject__image'),
            textHoverRevealmin = document.querySelector('#textRevealImagemin'),
            setX = gsap.quickSetter(imageRevealmin, "x", "px"),
            setY = gsap.quickSetter(imageRevealmin, "y", "px"),
            align = e => {
                const top = textHoverRevealmin?.getBoundingClientRect().top;
                const left = textHoverRevealmin?.getBoundingClientRect().left;
                setX(e.clientX - left);
                setY(e.clientY - top)
            },
            startFollow = () => document.addEventListener("mousemove", align),
            stopFollow = () => document.removeEventListener("mousemove", align),
            fade = gsap.to(imageRevealmin, { autoAlpha: 1, ease: "none", paused: true, onReverseComplete: stopFollow });
        textHoverRevealmin.addEventListener('mouseenter', (e) => {
            fade.play();
            startFollow();
            align(e);
        });
    
        textHoverRevealmin.addEventListener('mouseleave', () => fade.reverse());
    }

    return { 
        childsDetailProjectmin : function(){
            try{revealImageProjectmin();}catch(err){ }
        }
    }
})();

const getChildsDetailProjectmin = ()=>{
    detailProjectmin.childsDetailProjectmin();
}

export { getChildsDetailProjectmin }
